document.addEventListener("DOMContentLoaded", function () {
  // Swiper available hai ya nahi
  if (typeof Swiper === "undefined") {
    console.warn("[K-Beauty Hero] Swiper not found on window.");
    return;
  }

  // Har hero section ke liye alag init (multiple bhi ho sakte)
  const heroSections = document.querySelectorAll(".kbeauty-hero");
  if (!heroSections.length) {
    console.warn("[K-Beauty Hero] No .kbeauty-hero sections found.");
    return;
  }

  heroSections.forEach(function (section) {
    const swiperEl = section.querySelector("[data-hero-swiper]");
    const paginationEls = section.querySelectorAll(".kbeauty-pagination");

    if (!swiperEl || !paginationEls.length) {
      console.warn(
        "[K-Beauty Hero] Missing swiper or pagination in section.",
        section
      );
      return;
    }

    const mainPaginationEl = paginationEls[0];

    const swiper = new Swiper(swiperEl, {
      loop: false,
      speed: 600,
      spaceBetween: 16,
      pagination: {
        el: mainPaginationEl,
        clickable: true,
      },
      on: {
        init: function () {
          applyColors(this.slides[this.activeIndex]);
          syncPaginations();
        },
        slideChange: function () {
          applyColors(this.slides[this.activeIndex]);
          syncPaginations();
        },
      },
    });

    function applyColors(slide) {
      if (!slide) return;
      const card = slide.querySelector("[data-hero-root]");
      if (!card) return;

      const bg = slide.getAttribute("data-bg");
      const text = slide.getAttribute("data-text");
      const accent = slide.getAttribute("data-accent");

      if (bg) card.style.setProperty("--bg", bg);
      if (text) card.style.setProperty("--text", text);
      if (accent) card.style.setProperty("--accent", accent);
    }

    // main pagination se sab clones sync karo
    function syncPaginations() {
      paginationEls.forEach(function (el, index) {
        if (index === 0) return; // main already updated
        el.innerHTML = mainPaginationEl.innerHTML;
      });
    }

    // cloned paginations par click → slide change
    paginationEls.forEach(function (el, index) {
      if (index === 0) return;

      el.addEventListener("click", function (event) {
        const bullet = event.target.closest(".swiper-pagination-bullet");
        if (!bullet) return;

        const bullets = Array.from(
          el.querySelectorAll(".swiper-pagination-bullet")
        );
        const bulletIndex = bullets.indexOf(bullet);

        if (bulletIndex !== -1) {
          swiper.slideTo(bulletIndex);
        }
      });
    });
  });
});
document.querySelectorAll('.kbeauty-btn--hero').forEach(btn => {
  const accent = btn.dataset.accent; 

  btn.addEventListener('mouseenter', () => {
    btn.style.backgroundColor = '#006E37'; 
    btn.style.borderColor = '#006E37';
  });

  btn.addEventListener('mouseleave', () => {
    btn.style.backgroundColor = accent;
    btn.style.borderColor = accent;
  });
});

